import React from "react";
import { ArrowRight } from "lucide-react";
import { solutions } from "../mock";

import { tr } from "../i18n";
export default function Solutions({ onIllustration }) {
  return (
    <section id="solutions" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl mb-14 reveal">
          <div className="deco-line w-24 mb-6" />
          <h2 className="font-display text-[34px] md:text-[46px] text-[#0b1f3a] leading-tight">
            {tr("Savings management, tailored to your requirements")}
          </h2>
          <p className="text-[#0b1f3a]/60 text-[17px] mt-4">
            {tr("Whoever you are, we help you reduce risk and earn more on the cash you hold — all from a single application.")}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {solutions.map((s, i) => (
            <div
              key={s.id}
              id={s.id}
              className="reveal group relative rounded-2xl border border-[#0b1f3a]/8 bg-[#f6f2e9]/40 hover:bg-[#0b1f3a] p-8 transition-colors duration-300 scroll-mt-28"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <span className="font-display text-[15px] text-[#c2a15a]">
                0{i + 1}
              </span>
              <h3 className="font-display text-[26px] text-[#0b1f3a] group-hover:text-white mt-2 transition-colors">
                {s.title}
              </h3>
              <p className="text-[#0b1f3a]/60 group-hover:text-white/70 text-[15px] leading-relaxed mt-3 min-h-[72px] transition-colors">
                {s.body}
              </p>
              <button
                onClick={onIllustration}
                className="inline-flex items-center gap-2 mt-5 text-[14px] font-medium text-[#0b1f3a] group-hover:text-[#c2a15a] transition-colors"
              >
                {s.link}
                <ArrowRight
                  size={16}
                  className="transition-transform group-hover:translate-x-1"
                />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
